module.exports = __webpack_public_path__ + "static/img/Login_banner.51efe26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Login_banner.png
// module id = MZqJ
// module chunks = 7